<template>
  <div id="app" class="container" :class="containerClass">
    <md-progress-bar md-mode="indeterminate" class="md-primary page-loading" v-if="pageLoading" />
    <main-header />
    <md-content style="position:relative">
      <div class="container-wrapper md-layout-row" :class="containerClass">
        <div class="md-layout page-header">
          <div class="md-layout-item">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
                <h1 class="page-title">{{$t('rma-request')}}</h1>
              </div>
            </div>
          </div>
        </div>
        <div class="main-container" v-if="loading">
          <div class="code-loading">{{$t('loading-page')}}</div>
        </div>
        <router-view v-else />
      </div>
      <main-footer />
      <drop-menu />
    </md-content>
    <link href="https://img.creative.com/fontastic/creative-icons.css?v=1.1.1" rel="stylesheet"/>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import MainHeader from './MainHeader.vue'
  import MainFooter from './MainFooter.vue'
  import DropMenu from './DropMenu.vue'
  import { getStoreCodeByUrl, storeList } from '../mixins/store'

  export default {
    name: 'App',
    components: {
      MainHeader,
      MainFooter,
      DropMenu
    },
    data: () => ({
      loading: true,
      message: false
    }),
    computed: {
      ...mapState({
        isSplash: 'splashPage',
        store: 'store',
        pageLoading: 'pageLoading'
      }),
      containerClass() {
        return {
          splash: this.isSplash
        }
      }
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE
      })
    },
    created() {
      const code = getStoreCodeByUrl(location.href)
      if (code && storeList.indexOf(code) >= 0)
        this.changeStore(code)
      setTimeout(() => {
        this.loading = false
      }, 1500);
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  @import "../themes/default";

  body {
    height: 100%;
    overflow-x: hidden;
  }
</style>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  .container {
    min-height: 100%;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    transition: .4s cubic-bezier(.4, 0, .2, 1);
    transition-property: padding-top;
    }

    .main-header .md-toolbar-row, .main-footer-container
    {
      max-width: 1312px;
      margin: 0 auto;
    }



  .page-header {
    background: url(https://sg.creative.com/content2/images/help/header_help.jpg) center/cover no-repeat;
    color: #fff;
    text-align: right;
    margin-bottom: 40px;
    min-height: 80px;
    background-color: #ccc;
  }

  .container-wrapper {
    min-height: 550px;
    background-color: #FFF;
  }

  .main-container {
    flex: 1;
    position: relative;
    z-index: 1;
  }

  .code-loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 20px;
    text-align: center;
    width: 100%;
    display: block;
  }

  .version-message {
    .md-button:not(.md-accent)

  {
    color: #fff;
  }

  }

  .page-loading {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
  }

</style>

